import React, { useState}  from 'react';
import Carousel from './Carousel';
import img_price_zero from '../assets/img/img_price_zero.png';
import icon_price_zero from '../assets/img/icon_price_zero.svg';
import icon_simple_plin from '../assets/img/icon_simple_plin.svg';
import icon_plin from '../assets/img/icon_plin.svg';
import icon_transfer from '../assets/img/icon_transfer.svg';
import icon_transfers from '../assets/img/icon_tranfers.svg';
import icon_transfers_dark from '../assets/img/icon_tranfers_dark.svg';
import icon_smartphone from '../assets/img/icon_smartphone.svg';
import icon_participle from '../assets/img/icon_participle.svg';
import icon_receive_money_dollar from '../assets/img/icon_receive_money_dollar.svg';
import icon_mobile_cash_dollar from '../assets/img/icon_mobile_cash_dollar.svg';
import icon_savings from '../assets/img/icon_savings.svg';
import icon_free_dollar from '../assets/img/icon_free_dollar.svg';
import icon_sales from '../assets/img/icon_sales.svg';
import iconInfo from '../assets/img/icon_info.svg';
import DisclaimerSpherica from '../components/DisclaimerSpherica';
import '../css/components/BenefitsAccount.css';
import DropDown from '../components/DropDown';	

/**
* Literales Beneficios por tipo de Cuenta
*/
const FIRST_OFFER_DIGITAL= 'El costo de mantenimiento es S/ 0 sin importar el saldo que tengas.';
const ITEM_1_OFFER_DIGITAL = 'Envía y recibe dinero desde tu App BBVA con Plin';
const ITEM_2_OFFER_DIGITAL = 'Realiza transferencias interbancarias inmediatas';
const ITEM_1_DESCRIPTION_DIGITAL = 'Sin costo e inmediato.';
const ITEM_2_DESCRIPTION_DIGITAL = 'Sin costo hasta S/1000.';

const FIRST_OFFER_INDEPENDENCIA= 'S/ 0 costo de mantenimiento desde S/ 100 o $30 de saldo promedio mensual';
const ITEM_1_OFFER_INDEPENDENCIA = 'Realiza depósitos gratis e ilimitados';
const ITEM_2_OFFER_INDEPENDENCIA = 'Transfiere a otros bancos de forma inmediata';
const ITEM_1_DESCRIPTION_INDEPENDENCIA = 'En cajeros y Agentes BBVA.';
const ITEM_2_DESCRIPTION_INDEPENDENCIA = 'Gratis hasta S/ 1,000';

const FIRST_OFFER_GANADORA= 'Participa en sorteos por premios mientras ahorras.';
const ITEM_1_OFFER_GANADORA = 'Gana intereses';
const ITEM_2_OFFER_GANADORA = 'El costo de mantenimiento es S /0';
const ITEM_1_DESCRIPTION_GANADORA = 'Recibe intereses si ahorras desde S/ 1,500.';
const ITEM_2_DESCRIPTION_GANADORA = 'Si mantienes un saldo promedio mensual desde S/1,500 o $500.';
const TEXT_DISCLAIMER_GANADORA = 'El monto mínimo de apertura es de S/ 1,500 o $500, y se utiliza para calcular la TREA.';

const FIRST_OFFER_SUELDO= 'El costo de mantenimiento es S/ 0 mientras recibas tu sueldo en la cuenta.';
const ITEM_1_OFFER_SUELDO = 'Depósitos ilimitados e interplaza gratis';
const ITEM_2_OFFER_SUELDO = 'Disfruta de hasta 75% de descuento en establecimientos afiliados';
const ITEM_1_DESCRIPTION_SUELDO = 'En canales presenciales.';
const ITEM_2_DESCRIPTION_SUELDO = 'Consulta en tu App BBVA Beneficios.';

const FIRST_OFFER_VIP_WELLNESS = 'Sin costo de mantenimiento desde S/10,000 o Us$3,000 de saldo medio mensual';
const ITEM_1_OFFER_VIP_WELLNESS = 'Podrás acceder a tasas según el rango de saldo, hasta 4.5% en soles y 1.5% en dólares';
const ITEM_2_OFFER_VIP_WELLNESS = 'Accede a tu dinero al instante, cuando y donde lo necesites.';
const TEXT_DISCLAIMER_VIP_WELLNESS = 'El monto mínimo de apertura es de S/10,000 o US$3,000';

const BENEFICIOS_TIPO_CUENTA = {
    /**Cuenta Digital*/
    CNTCDBBVA: {
      firstOffer: FIRST_OFFER_DIGITAL,
      firstOfferImage: img_price_zero,
      items: [    
        { icon: icon_simple_plin, offer: ITEM_1_OFFER_DIGITAL, description: ITEM_1_DESCRIPTION_DIGITAL },
        { icon: icon_receive_money_dollar, offer: ITEM_2_OFFER_DIGITAL, description: ITEM_2_DESCRIPTION_DIGITAL }    
      ],
      itemsMobile: [
        { icon: icon_price_zero, offer: FIRST_OFFER_DIGITAL },    
        { icon: icon_plin, offer: ITEM_1_OFFER_DIGITAL, description: ITEM_1_DESCRIPTION_DIGITAL },
        { icon: icon_transfer, offer: ITEM_2_OFFER_DIGITAL, description: ITEM_2_DESCRIPTION_DIGITAL }  
      ]
    },
    /**Cuenta Independencia*/
    CNTIND: {
      firstOffer: FIRST_OFFER_INDEPENDENCIA,
      firstOfferImage: img_price_zero,
      items: [    
        { icon: icon_mobile_cash_dollar, offer: ITEM_1_OFFER_INDEPENDENCIA, description: ITEM_1_DESCRIPTION_INDEPENDENCIA },
        { icon: icon_transfers_dark, offer: ITEM_2_OFFER_INDEPENDENCIA, description: ITEM_2_DESCRIPTION_INDEPENDENCIA }    
      ],
      itemsMobile: [    
        { icon: icon_transfer, offer: FIRST_OFFER_INDEPENDENCIA, description: '' },
        { icon: icon_smartphone, offer: ITEM_1_OFFER_INDEPENDENCIA, description: ITEM_1_DESCRIPTION_INDEPENDENCIA },
        { icon: icon_transfers, offer: ITEM_2_OFFER_INDEPENDENCIA, description: ITEM_2_DESCRIPTION_INDEPENDENCIA }    
    ]
    },
    /**Cuenta Ganadora*/
    CNTGNDR: {
      firstOffer: FIRST_OFFER_GANADORA,
      firstOfferImage: img_price_zero,
      textoDisclaimer:TEXT_DISCLAIMER_GANADORA,
      items: [    
        { icon: icon_savings, offer: ITEM_1_OFFER_GANADORA, description: ITEM_1_DESCRIPTION_GANADORA },
        { icon: icon_free_dollar, offer: ITEM_2_OFFER_GANADORA, description: ITEM_2_DESCRIPTION_GANADORA }    
      ],
      itemsMobile: [    
        { icon: icon_participle, offer: FIRST_OFFER_GANADORA, description: '' },
        { icon: icon_smartphone, offer: ITEM_1_OFFER_GANADORA, description: ITEM_1_DESCRIPTION_GANADORA },
        { icon: icon_price_zero, offer: ITEM_2_OFFER_GANADORA, description: ITEM_2_DESCRIPTION_GANADORA }    
      ]
    },
    /**Cuenta Sueldo*/
    CNTSLD: {
      firstOffer: FIRST_OFFER_SUELDO,
      firstOfferImage: img_price_zero,
      items: [         
        { icon: icon_receive_money_dollar, offer: ITEM_1_OFFER_SUELDO, description: ITEM_1_DESCRIPTION_SUELDO },
        { icon: icon_sales, offer: ITEM_2_OFFER_SUELDO, description: ITEM_2_DESCRIPTION_SUELDO }    
      ],
      itemsMobile: [         
        { icon: icon_price_zero, offer: FIRST_OFFER_SUELDO, description: '' },
        { icon: icon_transfer, offer: ITEM_1_OFFER_SUELDO, description: ITEM_1_DESCRIPTION_SUELDO },
        { icon: icon_smartphone, offer: ITEM_2_OFFER_SUELDO, description: ITEM_2_DESCRIPTION_SUELDO }  
      ]
    },
    /**Cuenta Vip Wellness*/
    CNTVIP: {
      firstOffer: FIRST_OFFER_VIP_WELLNESS,
      firstOfferImage: img_price_zero,
      textoDisclaimer: TEXT_DISCLAIMER_VIP_WELLNESS,
      items: [
        { icon: icon_receive_money_dollar, offer: ITEM_1_OFFER_VIP_WELLNESS, description: '' },
        { icon: icon_sales, offer: ITEM_2_OFFER_VIP_WELLNESS, description: '' },
      ],
      itemsMobile: [
        { icon: icon_price_zero, offer: FIRST_OFFER_VIP_WELLNESS, description: '' },
        { icon: icon_transfer, offer: ITEM_1_OFFER_VIP_WELLNESS, description: '' },
        { icon: icon_smartphone, offer: ITEM_2_OFFER_VIP_WELLNESS, description: '' },
      ]
    },
  };

/**
* Función para buscar si existe los beneficios de una cuenta ingresada 
* */ 
const searchBenefit = (tipoCuenta) => {
  if (BENEFICIOS_TIPO_CUENTA[tipoCuenta]) {
    return true;
  }
  return false;
};

export default function BenefitsAccount({ cuentas, codigoCuentaPredeterminada, labelCuentaPredeterminada, callBackPrincipal }) {  
     
  const valueCodePredeterminado = codigoCuentaPredeterminada || '';
  const valueLabelPredeterminado = labelCuentaPredeterminada || '';  
  const [valueCuenta, setValueCuenta] = useState(valueCodePredeterminado);
  const [labelCuenta, setLabelCuenta] = useState(valueLabelPredeterminado);  

  function onChangeTipoCuenta(e) {
    let cuentaSeleccionadaValue = e ? e.value : '';
    let cuentaSeleccionadaLabel = e ? e.label : '';
    setValueCuenta(cuentaSeleccionadaValue);
    setLabelCuenta(cuentaSeleccionadaLabel);   

    let valueCuentaEnvio = cuentaSeleccionadaValue;
    let labelCuentaEnvio = cuentaSeleccionadaLabel;
    const existBenefit = searchBenefit(valueCuentaEnvio);

    let inputHTML =(
      existBenefit && BENEFICIOS_TIPO_CUENTA[valueCuentaEnvio].textoDisclaimer &&
      <React.Fragment>
        <div className='w-full h-fit flex md:hidden'>
          <div className='benefits-account-disclaimer-contenedor w-full'>
            <DisclaimerSpherica
              icon = {iconInfo}            
              iconWidth='24px'
              css='benefits-account-disclaimer-message' 
              cssIcon='benefits-account-disclaimer-icon'
              message={BENEFICIOS_TIPO_CUENTA[valueCuentaEnvio].textoDisclaimer}
            />
          </div>
        </div>
      </React.Fragment>
      );
      
    callBackPrincipal(inputHTML,valueCuentaEnvio,labelCuentaEnvio);
  } 

  return ((valueCodePredeterminado && valueLabelPredeterminado)?
    <div className='flex flex-col gap-5 text-font2'>
      <div className="flex flex-col items-center text-sphericaPrimary rounded-16 h-fit bg-white md:bg-sphericaSecondary md:p-8">
        <div className='flex flex-col gap-4 lg:pb-6 w-full'>
          <h2 className='font-bbvaMedium font-medium text-font2 md:text-font4'>Selecciona tu cuenta</h2>
        </div>        
        <div className='flex flex-col gap-4 lg:pb-1 w-full pt-16 md:pt-0'>
          <DropDown
            id={'cmbTipoCuenta'}
            options={cuentas}
            onChange={onChangeTipoCuenta} 
            cssValueStatus={'#FFFFFF'}
            cssValueContainer={'0px'}
            value={{value:valueCuenta?valueCuenta:valueCodePredeterminado,
                    label: labelCuenta?labelCuenta:valueLabelPredeterminado}}
          />
        </div> 
        {searchBenefit(valueCuenta?valueCuenta:valueCodePredeterminado) &&
        <React.Fragment>
          <div className='flex-col gap-4 lg:pb-1 w-full md:flex hidden'>          
            <div className='flex flex-row gap-8 justify-between items-center'>
              <div className='py-4'>
                <span className='text-font5 font-bbvaMedium font-medium'>
                  {BENEFICIOS_TIPO_CUENTA[valueCuenta?valueCuenta:valueCodePredeterminado].firstOffer}
                </span>
              </div>   
              <img src={BENEFICIOS_TIPO_CUENTA[valueCuenta?valueCuenta:valueCodePredeterminado].firstOfferImage} alt='tipo de cuenta' className='w-32'/>       
            </div>
          </div>
          <div className="hidden md:flex md:flex-col w-full gap-4">
            {BENEFICIOS_TIPO_CUENTA[valueCuenta?valueCuenta:valueCodePredeterminado].items.map(({ icon, offer, description }, index) => (
              <div key={index} className='flex flex-row gap-3 rounded-16 h-fit bg-txtSms px-6 py-6'>
                <img src={icon} alt='tipo de cuenta' className='h-8 w-8'/>
                <div>
                  <span className='text-font5 font-bbvaMedium font-medium'>{offer}</span>
                  <p className='text-font2 font-bbvaLight font-light'>{description}</p>
                </div>
              </div>
            ))}
          </div>
          {BENEFICIOS_TIPO_CUENTA[valueCuenta?valueCuenta:valueCodePredeterminado].textoDisclaimer && (
            <div className='pt-4 w-full h-fit hidden md:flex'>
              <div className='benefits-account-disclaimer-contenedor w-full'>
                <DisclaimerSpherica               
                  icon = {iconInfo}
                  iconWidth='24px'
                  css='benefits-account-disclaimer-message' 
                  cssIcon='benefits-account-disclaimer-icon'
                  message={BENEFICIOS_TIPO_CUENTA[valueCuenta?valueCuenta:valueCodePredeterminado].textoDisclaimer}
                />
              </div>
            </div>
          )}          
        </React.Fragment>}        
      </div>       
      {searchBenefit(valueCuenta?valueCuenta:valueCodePredeterminado) && 
      <div className="block md:hidden">
        <Carousel items={BENEFICIOS_TIPO_CUENTA[valueCuenta?valueCuenta:valueCodePredeterminado].itemsMobile} />
      </div>}
    </div>:''
  );
};